function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("filter", {
  id: "a",
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse",
  height: 1150,
  width: 1500,
  x: -30,
  y: -400
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  mode: "normal",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_52518_47117",
  stdDeviation: 200
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  gradientUnits: "userSpaceOnUse",
  x1: 1070,
  x2: 370,
  y1: 175,
  y2: 175
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#482bff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#482bff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#007aff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007aff",
  stopOpacity: 0
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1070 .0000306c0 45.9626694-9.05 91.4752694-26.64 133.9389694-17.59 42.464-43.372 81.048-75.873 113.548-32.5 32.501-71.084 58.282-113.548 75.871s-87.976 26.642-133.939 26.642-91.475-9.053-133.939-26.642-81.048-43.37-113.548-75.871c-32.501-32.5-58.282-71.084-75.871-113.548-17.589-42.4638-26.642-87.9763-26.642-133.939z",
  fill: "url(#b)"
}));

function SvgTopGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 750,
    viewBox: "0 0 1440 750",
    width: 1440,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopGradient);
export default __webpack_public_path__ + "static/media/TopGradient.9d508439f7438b9017fd9c471a653052.svg";
export { ForwardRef as ReactComponent };